import PropTypes from 'prop-types';
import React from 'react';

import Spinner from 'components/base/Spinner';

const Loading = ({ error, pastDelay }) => {
  if (error) {
    return <p>Error!</p>;
  } else if (pastDelay) {
    return <Spinner height="80" />;
  }
  return null;
};

Loading.defaultProps = {
  error: null,
};

Loading.propTypes = {
  error: PropTypes.bool,
  pastDelay: PropTypes.bool.isRequired,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/base/Loading.js